import Box from "@mui/material/Box";
import SubmitButton from "./SubmitButton";
import Modal from "@mui/material/Modal";
import React from "react";
import styled from "styled-components";
import CancelIcon from "../assets/createEnvAssets/CancelIcon";

const boxStyle = {
    position: 'absolute',
    padding: 1,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 650,
    outline: 'none',
    backgroundColor: 'background.paper',
    borderRadius: '5px',
};

const Container = styled.div`
  flex-direction: column;
  width:  '355px' ;
  justify-content: space-around;
  font-size: 14px;
  margin: 15px 10px 15px 0;
  align-items: center;
`;

const Description = styled.div`
  margin: 10px 10px 0 0 ;
  display: flex;
  align-items: center;
  flex-direction: column;

`;



const Footer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 20px 0 20px;
`;

const CancelButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
   font-size: 15px;

  .cancel_button {
    width: 10px;
    cursor: pointer;
  }
`;

const Message = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
   font-size: 15px;
  margin: 30px;
`;

const MessageModal= ({ modal, open, setOpen }) => {
    const { message= "", icon = null, component = null , submit="OK", cancel, fnOnSubmit=()=>{}, fnOnCancel=()=>{} } = modal;
    const Icon=icon;
    const Component=component;
    const handleOnApply = () => {
        setOpen(false);
        fnOnSubmit();
    }
    const handleOnCancel = () => {
        setOpen(false);
        fnOnCancel();
    }

    return(
        <Modal
            open={ open }
            sx={{ border: 'none' }}
            onClose={ handleOnCancel }
            className={ 'modal' }
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={ boxStyle }  id={"static-modal"}>
                <Container id={"container"}>
                    <CancelButtonWrapper id={"cancel_wrapper"} >
                                <span className={"cancel_button"} onClick={handleOnCancel}>
                                    <CancelIcon/>
                                </span>
                    </CancelButtonWrapper>
                    <Description id={"description"}>
                        { icon && <Icon id={"icon"}/>}
                        {  component &&  <Component/>}
                        <Message id={"message"}>
                            { message }
                        </Message>
                    </Description>
                    <Footer id={"footer"}>
                        <SubmitButton onClick={ handleOnApply }  label={ submit } width="120px" />
                        { cancel && <SubmitButton onClick={ handleOnCancel }  label={ "No" } width="120px" /> }
                    </Footer>
                </Container>
            </Box>
        </Modal>
    );

};

export default MessageModal;